import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/item/deleteaction";
import updateaction from "../../context/action/item/updateaction";

const Edititemmodal = (props) => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  const [error4, seterror4] = useState(false);
  const [error5, seterror5] = useState(false);
  const [error6, seterror6] = useState(false);
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
            <div className="relative my-2 sm:my-4 md:my-6 mx-auto w-full sm:w-4/5 md:w-2/3 lg:w-1/2">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* Header */}
                <div className="flex items-center justify-between p-3 sm:p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto text-black opacity-80 text-2xl sm:text-3xl leading-none font-semibold"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="block">X</span>
                  </button>
                </div>

                {/* Body */}
                <div className="relative p-4 sm:p-6 flex-auto">
                  <div className="flex flex-wrap w-full gap-4">
                    {/* Item Name Input */}
                    <div className="w-full md:w-[calc(50%-0.5rem)]">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2 
                          ${error ? "text-red-500" : "text-gray-700"}`}

                        for="grid-last-name"
                      >
                        ناوی کاڵا
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 text-gray-700 
                          border rounded py-2 sm:py-3 px-3 sm:px-4 leading-tight 
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error ? "border-red-500" : "border-gray-200"}`}
                        id="grid-last-name"
                        type="text"
                        placeholder="ناوی کاڵا"
                        value={props.item_name}
                        onChange={(val) => props.setitem_name(val.target.value)}
                        onFocus={() => seterror(false)}
                      />
                    </div>

                    {/* Barcode Input */}
                    <div className="w-full md:w-[calc(50%-0.5rem)]">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2
                          ${error1 ? "text-red-500" : "text-gray-700"}`}

                        for="grid-last-name"
                      >
                        باڕکۆد
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 text-gray-700 
                          border rounded py-2 sm:py-3 px-3 sm:px-4 leading-tight
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error1 ? "border-red-500" : "border-gray-200"}`}
                        id="grid-last-name"
                        type="number"
                        placeholder="باڕکۆد"
                        value={props.item_barcode}
                        onChange={(val) => props.setitem_barcode(val.target.value)}
                        onFocus={() => seterror1(false)}
                      />
                    </div>

                    {/* Price Input */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2
                          ${error2 ? "text-red-500" : "text-gray-700"}`}

                        for="grid-last-name"
                      >
                        نرخ
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 text-gray-700 
                          border rounded py-2 sm:py-3 px-3 sm:px-4 leading-tight
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error2 ? "border-red-500" : "border-gray-200"}`}
                        id="grid-last-name"
                        type="number"
                        placeholder="نرخ"
                        value={props.item_price}
                        onChange={(val) => props.setitem_price(val.target.value)}
                        onFocus={() => seterror2(false)}
                      />
                    </div>

                    {/* Category Select */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2
                          ${error5 ? "text-red-500" : "text-gray-700"}`}

                        for="catee"
                      >
                        کاتیگۆری کاڵا
                      </label>
                      <select
                        id="catee"
                        className={`block w-full bg-gray-50 text-gray-700 border rounded 
                          py-2 sm:py-3 px-3 sm:px-4 leading-tight
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error5 ? "border-red-500" : "border-gray-200"}`}
                        value={props.category_id}
                        onChange={(val) => {
                          props.setcategory_id(val.target.value);
                          seterror5(false);
                        }}
                      >
                        <option value="null">کاتیگۆری</option>
                        {initState.category.map((lis) => (
                          <option key={lis.category_id} value={lis.category_id}>
                            {lis.category_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex flex-wrap sm:flex-nowrap items-center justify-end gap-2 p-3 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    type="button"
                    onClick={() => {
                      if (window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") == true) {
                        deleteaction(props.item_id)(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    type="button"
                    onClick={() => {
                      if (props.item_name == "" || !props.item_name) {
                        seterror(true);
                        return false;
                      }
                      if (props.item_barcode == "" || !props.item_barcode) {
                        seterror1(true);
                        return false;
                      }
                      if (props.item_price < 0 || !props.item_price) {
                        seterror2(true);
                        return false;
                      }
                      // if (
                      //   props.item_min_notification < 0 ||
                      //   !props.item_min_notification
                      // ) {
                      //   seterror3(true);
                      //   return false;
                      // }
                      // if (
                      //   props.item_min_sell_price < 0 ||
                      //   !props.item_min_sell_price
                      // ) {
                      //   seterror6(true);
                      //   return false;
                      // }
                      if (props.category_id == "null" || !props.category_id) {
                        seterror5(true);
                        return false;
                      }
                      if (
                        window.confirm(
                          "ئاگاداری ئەنجامدانی گۆڕانکاری . دڵنیای ؟"
                        ) == true
                      ) {
                        updateaction(
                          props.item_name,
                          props.item_barcode,
                          props.item_price,
                          props.item_min_notification,
                          props.item_min_sell_price,
                          props.category_id,
                          props.item_id
                        )(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Edititemmodal;
